import { getPositionKey } from "@/Common/helpers/Positions";
import { useAuthorization } from "@/Common/hooks/Authorization/Authorization";
import { isEmpty } from "lodash";

export default function useCanAssignPayPlan(position: string): boolean {
	const { useAuth } = useAuthorization();

	if (isEmpty(position)) return false;
	const positionKey = getPositionKey(position);
	return useAuth(`EDIT_${positionKey}_PAY_PLAN_ASSIGNMENTS`);
}
